const translation = {
  nav_home: "Home",
  nav_about: "About Us",
  nav_products: "Products",
  nav_gallery: "Gallery",
  nav_contact: "Contact",
  nav_cta: "Contact Us",

  hero_badge: "Premium Bottling",
  hero_title: "Premium Cooking",
  hero_title2: "Oils",
  hero_subtitle: "We are leaders in premium oil bottling and distribution. Committed to excellence, we bring the finest oil to your table with the highest quality standards.",
  hero_btn1: "Our Products",
  hero_btn2: "Contact Us",

  about_badge: "Who We Are",
  about_title: "Tradition and Quality in Every Drop",
  about_process_label: "Packaging Processes",
  about_partner: "Your strategic partner in food oil",
  about_strategy: "Combining technology, traceability and corporate service",
  about_feature_quality_title: "Guaranteed Quality",
  about_feature_quality_desc: "Exhaustive control of every batch to comply with food standards.",
  about_feature_distribution_title: "National Distribution",
  about_feature_distribution_desc: "Coverage throughout the country with secure logistics and punctual deliveries.",
  about_feature_customer_title: "Customer Commitment",
  about_feature_customer_desc: "Personalized attention and reliable solutions for every supply chain.",
  about_feature_certified_title: "Certified Products",
  about_feature_certified_desc: "Oils with quality and traceability certifications.",
  about_p1: "We are a company specialized in bottling and distributing high-quality edible oils. With years of experience in the sector, we have established ourselves as a trusted reference for distributors, supermarkets, and food industry companies.",
  about_p2: "We work with the best palm, soy, sunflower, and olive oil suppliers, ensuring that every product we bottle meets the most rigorous quality and food safety controls.",
  about_p3: "Our bottling plant features state-of-the-art technology, automated production lines, and a dedicated team committed to excellence at every stage, from receiving bulk oil to the final product ready for distribution.",
  about_stat1: "25+",
  about_stat1_label: "Years of experience",
  about_stat2: "15",
  about_stat2_label: "Bottled brands",
  about_stat3: "8",
  about_stat3_label: "Types of oils",

  features_badge: "Our Commitment",
  features_title: "Commitment to Excellence",
  feat1_title: "Advanced Plant",
  feat1_desc: "State-of-the-art facilities for oil bottling with the highest hygiene and precision standards.",
  feat2_title: "Quality Certification",
  feat2_desc: "All our processes hold international quality and food safety certifications.",
  feat3_title: "Cold Chain",
  feat3_desc: "We maintain the cold chain throughout the process to guarantee the freshness and properties of the oil.",
  feat4_title: "National Distribution",
  feat4_desc: "Distribution network covering the entire national territory, guaranteeing timely deliveries.",
  feat5_title: "Custom Packaging",
  feat5_desc: "We offer customized packaging solutions in different presentations and sizes.",
  feat6_title: "Sustainability",
  feat6_desc: "Committed to the environment, we use recyclable materials and efficient processes.",

  products_badge: "Catalog",
  products_title: "Oil Product Line",
  products_subtitle: "Select a brand to explore its complete line of bottled oils with the highest quality standards.",
  products_presentations: "Available presentations",
  products_cta: "Request a Quote",
  products_hint: "Click on a presentation to see the corresponding container",

  brand_delsarten: "Delsarten",
  brand_delsarten_tagline: "Quality and tradition in every bottle — Delsarten Line",
  brand_miaceite: "Alimorca",
  brand_miaceite_tagline: "Authentic flavor for every kitchen — Alimorca Line",
  brand_alimorca_palma: "Alimorca Palm Oil",
  brand_alimorca_palma_tagline: "Quality and purity in every drop — Alimorca Palm Oil",

  ds_vegetal_name: "Delsarten Vegetable Oil",
  ds_vegetal_type: "Vegetable Oil",
  ds_soya_name: "Delsarten Soybean Oil",
  ds_soya_type: "Soybean Oil",

  ma_vegetal_name: "Alimorca Vegetable Oil",
  ma_vegetal_type: "Vegetable Oil",
  ma_soya_name: "Alimorca Soybean Oil",
  ma_soya_type: "Soybean Oil",
  ma_palma_name: "Alimorca Palm Oil",
  ma_palma_type: "Palm Oil",

  prod1_name: "Aceite Vegetal \"Delsarten\"",
  prod1_type: "Aceite Vegetal",
  prod1_desc: "",

  prod2_name: "Aceite de Soya \"Alimorca\"",
  prod2_type: "Aceite de Soya",
  prod2_desc: "",

 // prod3_name: "Sunflower Oil",
  //prod3_type: "Sunflower Oil",
  //prod3_desc: "First-quality sunflower oil with a neutral flavor and high smoke point. Ideal for all types of culinary preparations.",

  prod4_name: "Alimorca",
  prod4_type: "Aceite Vegetal",
  prod4_desc: "",

  prod5_name: "Extra Virgin Olive Oil",
  prod5_type: "Olive Oil",
  prod5_desc: "Extra virgin olive oil from first cold pressing. Characteristic aroma and flavor, ideal for salads and gourmet dishes.",

  prod6_name: "Blended Vegetable Oil",
  prod6_type: "Vegetable Oil",
  prod6_desc: "Balanced blend of vegetable oils for domestic and industrial use. Versatile, economical, and excellent performance.",

  gallery_badge: "Our Gallery",
  gallery_title: "Our Facilities and Products",
  gallery_subtitle: "Discover our packaging plant and the variety of oils we produce with the highest quality standards.",
  gallery_card1_title: "Production Line",
  gallery_card1_desc: "Automatic filling and quality control process to guarantee the purity of our oil.",
  gallery_card2_title: "Packaging",
  gallery_card2_desc: "Sealing and labeling with advanced technology to maintain the freshness and quality of the product.",
  gallery_card3_title: "Packaging",
  gallery_card3_desc: "Safe and resistant packaging to protect the product during transport and distribution.",
  gallery_card4_title: "Storage",
  gallery_card4_desc: "Storage under optimal conditions to ensure the availability and quality of our products.",

  contact_badge: "Contact",
  contact_title: "Contact Us",
  contact_subtitle: "Need information about our bottling and distribution services? We are here to help you.",
  contact_address_title: "Address",
  contact_address: "3801 Avalon Park E Blvd FL 2 STE 217, Orlando, Florida, United States",
  contact_phone_title: "Phone",
  contact_email_title: "Email",
  contact_hours_title: "Hours",
  contact_hours: "Monday to Friday: 9:00am - 5:00pm",
  form_name: "Full name",
  form_company: "Company",
  form_email: "Email address",
  form_phone: "Phone",
  form_subject: "Subject",
  form_message: "Message",
  form_submit: "Send Message",
  form_sending: "Sending...",
  form_consent: "By sending this form, you authorize the processing of the provided data to respond to your contact request.",
  form_success: "Message sent! We will get in touch soon.",

  footer_desc: "Leaders in bottling and distributing high-quality edible oils. Committed to excellence and customer satisfaction.",
  footer_links: "Quick Links",
  footer_services: "Products",
  footer_serv1: "Palm Oil",
  footer_serv2: "Soybean Oil",
  footer_serv3: "Corn Oil",
  footer_contact: "Contact",
  footer_rights: "All rights reserved.",
  footer_policy: "Privacy Policy",
  footer_terms: "Terms of Use",

  lang_toggle: "ES",
};

export default translation;
